import { create } from 'zustand';

interface DashboardState {
	specialistData: any;
	farmerData: any;
	setSpecialistData: (data: any) => void;
	setFarmerData: (data: any) => void;
}

export const useDashboardStore = create<DashboardState>((set) => ({
	specialistData: null,
	farmerData: null,
	setSpecialistData: (data) => set({ specialistData: data }),
	setFarmerData: (data) => set({ farmerData: data }),
}));
